import { useScrollToSection } from "../hooks/ScrollContext";
import { Step1, Step2, Step3, Step4 } from "../assets/images/image";

const HowItWork = () => {
    const { scrollToSection } = useScrollToSection();
    const listStep = [
        {
            id: 1,
            title: "STEP 1",
            description: "Choose your source (text, document, or audio).",
            icon: Step1
        },
        {
            id: 2,
            title: "STEP 2",
            description: "Select your subject and learning focus",
            icon: Step2
        },
        {
            id: 3,
            title: "STEP 3",
            description: "Let our AI generate your flashcards",
            icon: Step3
        },
        {
            id: 4,
            title: "STEP 4",
            description: "Start learning with spaced repetition",
            icon: Step4
        }
    ]
    return (
        <div className="w-full h-full">
            <div className="hidden md:flex items-start h-full">
                <div className="container flex items-center justify-around">
                    {listStep.map((item) => (
                        <div key={item.id} className="" data-reveal="up">
                            <h2 className="text-[24px] font-bold text-[#484848] font-inter text-center">{item.title}</h2>
                            <p className="text-[#484848] italic font-normal font-inter text-[14px] mt-4 mb-8 text-center max-w-[300px]">{item.description}</p>
                            <img src={item.icon} alt={item.title} loading="lazy" className="" />
                        </div>
                    ))}
                </div>
            </div>

            <div className="flex flex-col items-center gap-y-10 px-4 pt-6 md:hidden">
                <div className="w-full flex items-start">
                    <div className="flex items-center w-full">
                        <span
                            className="text-[17px] font-normal font-inter text-[#484848] cursor-pointer hover:underline bg-[#D9D9D9] me-6 pt-[4px] pb-[4px] ps-[8px] pe-[8px] rounded-[16px]"
                            onClick={() => scrollToSection("home")}
                        >
                            Home
                        </span>
                        <div className="bg-[#FFD600] me-6 pt-[4px] pb-[4px] ps-[8px] pe-[8px] rounded-[16px]">
                            <span className="text-[17px] font-normal font-inter text-[#484848] mx-2">→</span>
                            <span className="text-[17px] font-bold font-inter text-[#484848]">
                                How it works
                            </span>
                        </div>
                    </div>
                </div>
                <h2 className="text-[24px] font-light font-inter text-[#484848] text-center" data-reveal="up">
                    How it works
                </h2>
                {listStep.map((item) => (
                    <div key={item.id} className="" data-reveal="up">
                        <h2 className="text-[24px] font-bold text-[#484848] font-inter text-center">{item.title}</h2>
                        <p className="text-[#484848] italic font-normal font-inter text-[14px] mt-4 mb-8 text-center w-full">{item.description}</p>
                        <img src={item.icon} alt={item.title} loading="lazy" className="" />
                    </div>
                ))}
            </div>
        </div>
    )
}
export default HowItWork;